import { Component } from 'react';
import styled from 'styled-components';

const Style = styled.div`
  position: relative;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  font-size: inherit;
  text-indent: -9999em;
  animation: load5 1.1s infinite ease;
  transform: translateZ(0);

  @keyframes load5 {
    0%,
    100% {
      box-shadow: 0em -2.6em 0em 0em #1c1c1c, 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2),
        2.5em 0em 0 0em rgba(51, 51, 51, 0.2), 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.2),
        0em 2.5em 0 0em rgba(51, 51, 51, 0.2), -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.2),
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.5), -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.7);
    }
    12.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.7), 1.8em -1.8em 0 0em #1c1c1c,
        2.5em 0em 0 0em rgba(51, 51, 51, 0.2), 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.2),
        0em 2.5em 0 0em rgba(51, 51, 51, 0.2), -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.2),
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.2), -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.5);
    }
    25% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.5), 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.7),
        2.5em 0em 0 0em #1c1c1c, 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.2),
        0em 2.5em 0 0em rgba(51, 51, 51, 0.2), -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.2),
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.2), -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2);
    }
    37.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.2), 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.5),
        2.5em 0em 0 0em rgba(51, 51, 51, 0.7), 1.75em 1.75em 0 0em #1c1c1c,
        0em 2.5em 0 0em rgba(51, 51, 51, 0.2), -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.2),
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.2), -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2);
    }
    50% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.2), 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2),
        2.5em 0em 0 0em rgba(51, 51, 51, 0.5), 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.7),
        0em 2.5em 0 0em #1c1c1c, -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.2),
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.2), -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2);
    }
    62.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.2), 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2),
        2.5em 0em 0 0em rgba(51, 51, 51, 0.2), 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.5),
        0em 2.5em 0 0em rgba(51, 51, 51, 0.7), -1.8em 1.8em 0 0em #1c1c1c,
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.2), -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2);
    }
    75% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.2), 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2),
        2.5em 0em 0 0em rgba(51, 51, 51, 0.2), 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.2),
        0em 2.5em 0 0em rgba(51, 51, 51, 0.5), -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.7),
        -2.6em 0em 0 0em #1c1c1c, -1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2);
    }
    87.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(51, 51, 51, 0.2), 1.8em -1.8em 0 0em rgba(51, 51, 51, 0.2),
        2.5em 0em 0 0em rgba(51, 51, 51, 0.2), 1.75em 1.75em 0 0em rgba(51, 51, 51, 0.2),
        0em 2.5em 0 0em rgba(51, 51, 51, 0.2), -1.8em 1.8em 0 0em rgba(51, 51, 51, 0.5),
        -2.6em 0em 0 0em rgba(51, 51, 51, 0.7), -1.8em -1.8em 0 0em #1c1c1c;
    }
  }
`;

export default class LoadingSpinner extends Component {
  render() {
    return <Style></Style>;
  }
}
